import React from 'react';
// import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './NewCircleModalSearch.scss';

import CuratorCardNew from '../../../Curators/CuratorCardNew';
import InputActions from '../../../General/InputActions';

import { fetchAlgoliaIndex } from '../../../../Helpers/search_helpers';

const NewCircleModalSearch = props => {
  const { selectedCurators } = props;

  const [curSearchVal, setCurSearchVal] = React.useState('');
  const [isFetching, setIsFetching] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState([]);

  const debounceSearch = React.useRef(null);
  const storeSearchIndexRef = React.useRef(fetchAlgoliaIndex(`store_${window.__IS_PROD__ ? 'production' : 'staging'}`));

  React.useEffect(() => {
    if (curSearchVal) {
      setIsFetching(true);
      debounceSearch.current = setTimeout(() => {
        window.__ADD_EVENT__('Shop - New Circle Modal - Search', { searchVal: curSearchVal });

        storeSearchIndexRef.current
          .search(curSearchVal, {
            page: 0,
            facetFilters: [['type:Curator']],
            hitsPerPage: 25
          })
          .then(({ hits }) => setSearchResults(hits))
          .catch(() => window.ALERT.error('There was an error, please try again.'))
          .finally(() => setIsFetching(false));
      }, 250);
      return () => {
        clearTimeout(debounceSearch.current);
      };
    }
  }, [curSearchVal]);

  const isFetchingInitialResults = isFetching && !searchResults.length;
  const hasNoResults = !isFetching && !searchResults.length && !!curSearchVal;

  const inputRef = React.useRef(null);
  const resetSearch = () => {
    setCurSearchVal('');
    inputRef.current && inputRef.current.focus();
  };

  const additionalClasses = { fetching: isFetching };
  return (
    <div className='new-circle-modal-search-container'>
      <div className='search-header'>
        <div className='search-input-container has-actions'>
          <InputActions searchVal={curSearchVal} onCancel={resetSearch} />
          <input
            ref={inputRef}
            type='text'
            placeholder='What ShopMy curator are you looking for?'
            autoFocus
            value={curSearchVal}
            onChange={e => setCurSearchVal(e.target.value)}
          />
        </div>
      </div>
      {hasNoResults ? (
        <div className='no-results'>
          <div className='title'>No curators found with the name or social handle of "{curSearchVal}"</div>
          <div className='description'>
            We only allow searching for curators who pass our Trendsetter or Icon threshold, to add other curators to your circle, please ask them to
            send you their shop profile and you can use the heart to add them to your circle.
          </div>
        </div>
      ) : (
        <div className={cn('search-results', additionalClasses)}>
          {isFetchingInitialResults || !curSearchVal
            ? _.range(16).map(idx => <div className='search-result loading' key={idx} />)
            : searchResults.map(algoliaCurator => {
                const curator = {
                  id: algoliaCurator.Curator_id,
                  image: algoliaCurator.image,
                  name: algoliaCurator.highlightedParts?.[0] || algoliaCurator.term,
                  username: algoliaCurator.Curator_username
                };
                const isSelected = selectedCurators.some(sc => sc.id === curator.id);
                const isAnotherSelected = !isSelected && !!selectedCurators.length;

                const toggle = () =>
                  isSelected
                    ? props.setSelectedCurators(selectedCurators.filter(sc => sc.id !== curator.id))
                    : props.setSelectedCurators([...selectedCurators, curator]);

                return (
                  <CuratorCardNew
                    curator={curator}
                    isLoading={isFetching}
                    isSelectable
                    isSelected={isSelected}
                    isAnotherSelected={isAnotherSelected}
                    onToggle={toggle}
                    searchResultCurator={curator}
                    key={curator.id}
                  />
                );
              })}
        </div>
      )}
    </div>
  );
};

NewCircleModalSearch.propTypes = {
  shop: PropTypes.object.isRequired,
  selectedCurators: PropTypes.array.isRequired,
  closeSearch: PropTypes.func.isRequired
};

export default NewCircleModalSearch;
